<template>
  <CustomModal ref="modal" class="select-client-order-modal" title="Associer à un dossier">
    <div>
      <p class="intro">Choisissez le dossier auquel associer ce devis.</p>
      <div class="orders">
        <button v-for="order in orders" :key="order.number" type="button" class="order" :class="{selected: order.number === selectedNumber}" @click="selectedNumber = order.number">
          <span class="number">Dossier n°{{ order.number }}</span>
          <span class="title" :title="order.title">{{ order.title ? order.title : "Sans titre" }}</span>
          <span class="contracts">{{ contractsLabel(order) }}</span>
        </button>
      </div>
      <CustomButton class="submit-button" @click="submit" :params=buttons.submit style="margin-top: 20px" />
    </div>
  </CustomModal>
</template>

<script>
import CustomButton from "@/components/forms/customs/customButton/CustomButton.vue";
import CustomModal from "@/components/modals/CustomModal.vue";
import {documentRef} from "@/accounting/services/export/AccountingFormat";

// Choix du dossier auquel rattacher un nouveau devis quand le client en a plusieurs. Le choix est remonté au parent par la fonction callback.
export default {
  name: 'SelectClientOrderModal',
  props: ['callback'],
  components: {CustomModal, CustomButton},
  data() {
    return {
      orders: [],
      selectedNumber: undefined,
      buttons: {
        submit: {text: "Valider", disabled: true}
      }
    };
  },
  watch: {
    selectedNumber(value) {
      this.buttons.submit.disabled = value === undefined;
    }
  },
  methods: {
    openModal(orders, selectedNumber) {
      this.orders = orders;
      this.selectedNumber = selectedNumber;
      this.buttons.submit.disabled = selectedNumber === undefined;
      this.$refs.modal.openModal();
    },
    closeModal() {
      this.$refs.modal?.closeModal();
    },
    // Contrats déjà dans le dossier, pour reconnaître le bon : D0004 (FA0002) · D0007
    contractsLabel(order) {
      return (order.contracts ?? [])
          .map(contract => documentRef('D', contract.number) + (contract.invoiceNumber > 0 ? ' (' + documentRef('FA', contract.invoiceNumber) + ')' : ''))
          .join(' · ');
    },
    submit() {
      if (this.selectedNumber === undefined) return;
      this.closeModal();
      this.callback(this.selectedNumber);
    }
  }
}
</script>

<style lang="stylus" scoped>
@require '~/src/common/style/common.styl';

.intro
  margin 0 0 15px
  font-size 14px
  color FONT_COLOR

// Pas de défilement dans la modale : les dossiers se répartissent sur deux colonnes
.orders
  display grid
  grid-template-columns 1fr 1fr
  gap 10px

.order
  display flex
  flex-direction column
  gap 2px
  min-width 0
  padding 10px 12px
  text-align left
  border 1px solid CTRL_BORDER
  border-radius CTRL_RADIUS
  background CTRL_BG
  color FONT_COLOR
  cursor pointer
  transition background CTRL_EASE, border-color CTRL_EASE
  &:hover
    border-color CTRL_BORDER_HOVER
    background CTRL_BG_HOVER
  // Option choisie : en bleu
  &.selected
    border-color CTRL_FOCUS
    background #e6edfa
    box-shadow 0 0 0 2px CTRL_FOCUS_RING

.number
  font-weight 700

.title, .contracts
  overflow hidden
  text-overflow ellipsis
  white-space nowrap

.title
  font-size 14px

.contracts
  font-size 12px
  color CTRL_TEXT_MUTED

.submit-button
  display block
  margin-left auto
  margin-right auto
  width 200px

@media only screen and (max-width: TABLET_SIZE)
  .orders
    grid-template-columns 1fr
</style>

<style lang="stylus">
  .select-client-order-modal .modal
    width 640px !important
</style>
